module.exports = __webpack_public_path__ + "static/media/login_background.6c7af800.png";